import PageVendor from "../../../../../component/page/vendor/PageVendor";
import VendorNav from "../../../../../logic/navigation/vendorNav";
import AccountLayout from "../../../../../component/account/layout/structure/AccountLayout";
import AccountTertiaryNav from "../../../../../component/account/layout/structure/AccountTertiaryNav";

const breadcrumbTrail = [VendorNav.items.home, {...VendorNav.items.dashboard, selected: true}]

export const PageDashboard = () => {

    return (
        <PageVendor>

            <AccountLayout breadcrumbTrail={breadcrumbTrail}>
                <AccountTertiaryNav navList={VendorNav.items.dashboard.children} />
            </AccountLayout>
        </PageVendor>
    )

}
